import Bookings from '../components/templates/bookings';

export const BookingsContainer = () => {
  return <Bookings />;
};
